import { Component, input } from '@angular/core';
import { AdminIconComponent } from './admin-icon.component';
import type { LucideIconInput } from '@lucide/angular';

@Component({
  selector: 'app-admin-card',
  standalone: true,
  imports: [AdminIconComponent],
  template: `
    <article class="cg-admin-card" [class.cg-admin-grid--span-2]="span2()">
      @if (title() || icon()) {
        <header class="cg-admin-card__header">
          <div class="cg-admin-card__header-left">
            @if (icon(); as iconName) {
              <span class="cg-admin-card__icon" aria-hidden="true">
                <app-admin-icon [name]="iconName" />
              </span>
            }
            <div>
              @if (title()) {
                <h2 class="cg-admin-card__title">{{ title() }}</h2>
              }
              @if (subtitle()) {
                <p class="cg-admin-card__subtitle">{{ subtitle() }}</p>
              }
            </div>
          </div>
          <ng-content select="[headerActions]" />
        </header>
      }
      <div class="cg-admin-card__body">
        <ng-content />
      </div>
    </article>
  `,
})
export class AdminCardComponent {
  readonly title = input<string>();
  readonly subtitle = input<string>();
  readonly icon = input<LucideIconInput>();
  readonly span2 = input(false);
}
